﻿/**
* DevExpress Analytics (widgets\internal\_popupComponentBase.js)
* Version:  22.2.6
* Build date: Apr 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { Disposable } from '../../serializer/utils';
export class PopupComponentBase extends Disposable {
    constructor() {
        super(...arguments);
        this._component = ko.observable();
        this.onContentReady = (e) => {
            this._component(e.component);
        };
        this.hideOnOutsideClick = (e) => {
            var component = this.getComponent();
            var $content = component && $.fn.constructor(component.content());
            return !$content || !($content.has(e.target).length || $content.is(e.target));
        };
    }
    getComponent() {
        return ko.unwrap(this._component);
    }
    dispose() {
        super.dispose();
        var component = this._component();
        component && component.dispose();
        this._component(null);
    }
}
